<template>
  <div class="author-course">
    <div class="course-management">
      <h1 class="course-title" @click="goback">
        <span class="icon-back"></span>新建课程
      </h1>
      <div class="line"></div>
      <el-form :model="courseModel" :rules="rules" ref="courseModel" label-width="120px" label-position="left"
        class="courseModel">
        <el-form-item label="课程标题" prop="title">
          <el-input v-model="courseModel.title" class="text-input"></el-input>
        </el-form-item>
        <el-form-item label="主讲人" prop="author">
          <el-input v-model="courseModel.author" disabled class="text-input"></el-input>
        </el-form-item>
        <el-form-item label="课程封面" prop="coverImageUrl">
          <el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="true"
            :before-upload="beforeImageUpload" :on-success="handleImageSuccess" :accept="'image/*'">
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div class="tip">
            <span>(图片建议尺寸 854*480)</span>
          </div>
        </el-form-item>
        <el-form-item label="课程类型" prop="type">
          <el-radio-group v-model="courseModel.type">
            <el-radio label="2">月课</el-radio>
            <el-radio label="3">年课</el-radio>
            <el-radio label="1">专辑</el-radio>
            <el-radio label="5">订阅</el-radio>
            <!-- <el-radio label="4">合集</el-radio> -->
          </el-radio-group>
        </el-form-item>
        <el-form-item label="类型描述" prop="typeDescription">
          <el-input v-model="courseModel.typeDescription" class="text-input"></el-input>
          <div class="tip">
            <span>
              1.月课可填写月份 例如:2018年1月
              <br />2.合集课填写月份 例如:2018年1月-7月 <br />3.专辑可填写标签
              例如:技术面
            </span>
          </div>
        </el-form-item>
        <el-form-item label="期望定价" prop="expectedPrice">
          <el-input v-model="courseModel.expectedPrice" class="text-input"></el-input>
        </el-form-item>
        <el-form-item label="最大服务人数" prop="maxServedPersons">
          <el-input :disabled="maxServedNoLimit" v-model.number="courseModel.maxServedPersons"
            class="text-input"></el-input>
          <el-checkbox @change="noLimitChange" :class="'sn-ckb'" v-model="maxServedNoLimit">不限</el-checkbox>
        </el-form-item>
        <el-form-item label="课程介绍" prop="courseIntroduction">
          <el-input type="textarea" :rows="4" placeholder="输入课程介绍" v-model="courseModel.courseIntroduction"
            class="textarea-input"></el-input>
        </el-form-item>
        <el-form-item label="视频介绍" prop="fileName">
          <el-input v-model="courseModel.videoIntroduction" class="text-input" placeholder="输入视频标题"></el-input>
          <el-input v-model="courseModel.fileName" disabled class="text-input" prop="fileName"
            style="margin-left: 15px"></el-input>
          <aliyun-upload class="ailiyunupLoad" @uploadComplete="onUploadComplete($event)"
            @startUpload="onStartUpload($event)" @uploadProgress="onUploadProgress($event)"
            @uploadCanceled="onUploadCanceled($event)" @onError="onError" v-bind:temp="`MP4`" :fileType="`video`"
            :showCacelBtn="true">
            <el-button :loading="fileUploading" style="margin-left: 15px" type="primary">上传文件</el-button>
            <el-progress :width="35" class="progress-style" v-if="videoPercentage !== 0" type="circle"
              :percentage="videoPercentage" status="success" :stroke-width="2"></el-progress>
          </aliyun-upload>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="courseModel.checked" prop="checked">
            我已阅读并同意
            <a href="#" style="text-decoration: none">《有看投课程开通及上架协议》</a>
          </el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('courseModel')">提交</el-button>
          <el-button @click="resetForm('courseModel')">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="contact-panel">
      <author-contact-us></author-contact-us>
    </div>
  </div>
</template>

<script>
import AliyunUpload from '@/components/AliyunUpload/AliyunUpload'
import Urls from '@/assets/js/Urls'
import { createCourse } from '@/api/authorcourse'
import AuthorContactUs from '@/components/AuthorContactUs'
export default {
  name: 'NewCourse',
  components: { AliyunUpload, AuthorContactUs },
  data() {
    const validateMoney = (rule, value, callback) => {
      if (isNaN(value)) {
        callback(new Error('价格格式不正确'))
      } else if (value.indexOf('.') !== -1 && value.split('.').length > 2) {
        callback(new Error('请输入正确格式的金额'))
      } else if (value.indexOf('.') !== -1 && value.split('.')[1].length > 2) {
        callback(new Error('做多支持两位小数'))
      } else {
        callback()
      }
    }
    const checkAgree = (rule, value, callback) => {
      if (!this.courseModel.checked) {
        callback(new Error('请勾选我已阅读并同意条款'))
      }
    }
    return {
      fileUploading: false,
      uploadUrl: `${Urls.DOMAIN_STATIC}/Upload/Image`,
      imageUrl: null,
      videoPercentage: 0,
      maxServedNoLimit: false,
      courseModel: {
        title: '',
        author: '',
        coverImageUrl: '',
        type: '',
        typeDescription: '',
        expectedPrice: '',
        maxServedPersons: '',
        courseIntroduction: '',
        videoIntroduction: '',
        fileName: '',
        mediaId: '',
        checked: false
      },
      rules: {
        title: [
          {
            required: true,
            message: '请填写课程标题',
            trigger: 'blur'
          }
        ],
        author: [
          {
            required: true,
            message: '请填写主讲人',
            trigger: 'blur'
          }
        ],
        coverImageUrl: [
          {
            required: true,
            message: '请上传课程封面',
            trigger: 'blur'
          }
        ],
        typeDescription: [
          {
            required: true,
            message: '请填写类型描述',
            trigger: 'blur'
          }
        ],
        expectedPrice: [
          {
            required: true,
            message: '请填写期望定价',
            trigger: 'blur'
          },
          {
            type: 'string',
            required: true,
            trigger: 'blur',
            validator: validateMoney
          }
        ],
        maxServedPersons: [
          {
            required: true,
            message: '请填写最大服务人数',
            trigger: 'change'
          },
          { type: 'integer', message: '请输入整数', trigger: 'blur' }
        ],
        courseIntroduction: [
          {
            required: true,
            message: '请填写课程介绍',
            trigger: 'blur'
          }
        ],
        type: [
          {
            required: true,
            message: '请填写课程类型',
            trigger: 'blur'
          }
        ],
        fileName: [
          {
            required: true,
            message: '请上传视频',
            trigger: 'blur'
          }
        ],
        checked: [
          {
            type: 'string',
            message: '请勾选我同意协议',
            trigger: 'blur',
            validator: checkAgree
          }
        ]
      }
    }
  },
  created() {
    console.log(this.$store.state.user.nick)
    var authorNickName =
      this.$store.state.user.authorInfo != null
        ? this.$store.state.user.authorInfo.nickname
        : ''
    if (!authorNickName) {
      authorNickName =
        this.$store.state.user != null
          ? this.$store.state.user.userInfo.nick
          : ''
    }

    this.courseModel.author = authorNickName
  },
  computed: {},
  methods: {
    goback() {
      this.$router.go(-1)
    },
    onUploadComplete(videoInfo) {
      console.log('完成')
      this.videoPercentage = 100
      this.courseModel.fileName = videoInfo.title
      this.courseModel.mediaId = videoInfo.mediaId
      this.fileUploading = false
    },
    onStartUpload(videoInfo) {
      console.log('开始')
      this.fileUploading = true
    },
    onUploadProgress(progress) {
      this.videoPercentage = Math.round(progress * 100)
    },
    onUploadCanceled(videoInfo) {
      console.log('取消')
      this.fileUploading = false
    },
    onError(msg) {
      this.$alert(msg, '提示', {
        type: 'warning'
      }).then(() => { })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    beforeImageUpload(file) {
      if (file.type.split('/')[0] !== 'image') {
        this.$alert('请上传【图片】类型的文件', '提示', {
          type: 'warning'
        }).then(() => { })
        return false
      }
    },
    handleImageSuccess(res, file) {
      this.courseModel.coverImageUrl = this.imageUrl =
        res.result.code === 0 ? res.detail : null
    },
    async submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (!this.courseModel.checked) {
            this.$message.info('请阅读并同意协议《有看投课程开通及上架协议》')
            return false
          }
          this.submit()
        } else {
          return false
        }
      })
    },
    async submit() {
      var model = {
        title: this.courseModel.title,
        imgUrl: this.courseModel.coverImageUrl,
        courseSetType: this.courseModel.type,
        subTitle: this.courseModel.typeDescription,
        price: this.courseModel.expectedPrice,
        maxServiceNum: this.courseModel.maxServedPersons,
        remark: this.courseModel.courseIntroduction,
        videoTitle: this.courseModel.videoIntroduction,
        videoId: this.courseModel.mediaId
      }
      const data = await createCourse(model)
      if (data) {
        this.$message.info('创建课程成功')
        // this.$router.push({ path: '/author-course' })
        this.$router.push({ path: '/excl-author/course' })
      }
    },
    noLimitChange(val) {
      if (val) {
        this.$set(this.courseModel, 'maxServedPersons', 99999)
      }
    }
  }
}
</script>
<style lang="scss">
.progress-style {
  margin-left: 10px;
  vertical-align: bottom;
}

.el-input {
  vertical-align: top;
}
</style>
<style lang="scss" scoped>
.tip {
  display: inline-block;
  margin-left: 15px;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 1px;
  vertical-align: top;
  color: #858585;
}

.line {
  display: block;
  flex: 1 1 0px;
  max-width: 95%;
  margin-top: 10px;
  margin-left: 20px;
  height: 0;
  max-height: 0;
  border: solid 1px lightgray;
  border-width: thin 0 0;
  transition: inherit;
}

.author-course {
  display: flex;
}

.course-management {
  min-width: 800px;
  min-height: 1100px;
  margin-right: 20px;
  background-color: #ffffff;
  border: solid 1px #ebebeb;
  border-radius: 5px;
  flex: auto;
}

.course-title {
  padding-left: 30px;
  padding-top: 10px;
  font-size: 16px;
  height: 28px;
  font-weight: bold;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 1px;
  color: #262626;
  cursor: pointer;
}

.avatar-uploader {
  width: 180px;
  display: inline-block;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  display: inline-block;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  border: 1px dashed #ebebeb;
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.courseModel {
  padding-top: 40px;
  padding-left: 30px;
}

.text-input {
  width: 180px;
}

.textarea-input {
  width: 500px;
  background-color: #fafafa;
  border-radius: 5px;
  border: solid 1px #ebebeb;
}

.sn-ckb {
  margin-left: 60px;
}

.upload-video {
  margin-left: 10px;
  display: inline-block;
}

.icon-back {
  position: relative;
  display: inline-block;
  width: 18px;
  height: 2px;
  margin-right: 10px;
  margin-bottom: 5px;
  background-color: #a3a29e;

  &::before {
    content: '';
    position: absolute;
    left: -1px;
    top: 20%;
    margin-top: -9px;
    width: 8px;
    height: 8px;
    border-left: 2px solid #a3a29e;
    border-bottom: 2px solid #a3a29e;
    transform: rotate(45deg);
    transform-origin: 0 100%;
  }
}

.contact-panel {
  width: 314px;
  flex: none;
  border-radius: 5px;
  background-color: #ffffff;
}
</style>
